import React from 'react';

const CTA = () => {
    return (
        <section className="bg-gradient-to-r from-red-900 to-black text-white px-6 md:px-16 py-20 text-center">
            <div className="max-w-2xl mx-auto" data-aos="zoom-in-up" data-aos-duration="800">
                <h2 className="text-3xl font-bold mb-4">
                    Ready to Boost Your Cyber Defense?
                </h2>
                <p className="text-gray-300 mb-6">
                    Join companies and individuals across Indonesia who trust SiberLab ID for their cybersecurity needs.
                </p>
                <a
                    href="#contact"
                    className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded transition"
                >
                    Get Started
                </a>
            </div>
        </section>
    );
};

export default CTA;
